'use strict';

import uuid from 'uuid';

/**
 * @property {String}         id              - unique id of lore
 * @property {String}         title           - unique title of lore
 * @property {Array<String>}  lore            - array of lore
 * @property {Array<String>}  authors         - array of user ids
 * @property {String}         permissions     - maps to users' role, restricts view ability to specific role. This will-
                                                override the individual content block permissions.
 * @property {String}         campaignSetting - parent campaign setting
 * @property {Date}           created         - timestamp of lore creation
 * @property {Date}           modified        - timestamp of lore update
 */
export default class Lore {
  /**
   * @param {String}        id
   * @param {String}        title
   * @param {Array<String>} lore
   * @param {Array<String>} authors
   * @param {String}        permissions
   * @param {String}        campaignSetting
   * @param {Date}          created
   * @param {Date}          modified
   */
  constructor(id, title, lore, authors, permissions, campaignSetting, created, modified) {
    this.id = id || uuid.v4();
    this.title = title || null;
    this.lore = lore || [];
    this.authors = authors || [];
    this.permissions = permissions || 'gm';
    this.campaignSetting = campaignSetting || null;
    this.created = created || new Date();
    this.modified = modified || new Date();
  }
}